/**
 * Shared PWA helpers (install prompt, iOS detection).
 */

export function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

/** True when running as installed PWA (standalone). */
export function isStandaloneDisplayMode() {
  if (typeof window === 'undefined') return false;
  if (navigator.userAgent.includes('MosqifyFlutterApp')) return true;
  if (window.matchMedia('(display-mode: standalone)').matches) return true;
  if (window.navigator.standalone === true) return true;
  if (localStorage.getItem('pwa-installed') === 'true') return true;
  return false;
}
